export default __webpack_public_path__ + "static/media/piechart.7d7b8f4c.png";